import React, { useState , useEffect}  from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import {getParametros} from '../../services/parametros';
import {useParametrosMutations} from '../../hooks/parametros/useParametrosMutations';
import { Toaster,toast } from 'react-hot-toast';

const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
      <button
        type="button"
        onClick={() => customFunc()}
        style={{ backgroundColor: color}}
        className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
      >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    </button>

  </TooltipComponent>
);

const Parametros = () => {
    const { currentColor, handleClick, isClicked } = useStateContext();
    const [paramData, setParamData] = useState([]);
    const {updateParam } = useParametrosMutations();

    useEffect(()=>{
      const fetchData = async () => {
        const misParam = await getParametros();
        console.log("Parametros obtenidos: ", misParam);
        setParamData(misParam);
      };
      fetchData();
    },[]);

    const handleInputChange = (index, e) => {
      const newParamData = [...paramData]; // copiamos el array
      newParamData[index].valorParametro = e.target.value; // actualizamos el valor
      setParamData(newParamData); // actualizamos el estado
    };


    const handleSubmit = async () => {
      try {
            paramData.forEach(element => {

              let dataMod = {
                _id: element._id,
                empresa: element.empresa,
                codigoParametro: element.codigoParametro ,
                descripcionParametro: element.descripcionParametro,
                valorParametro: element.valorParametro,
                valorParametro2:  element.valorParametro2,
                estado:  element.estado,
                fechaCreacion: element.fechaCreacion
              };
              updateParam.mutateAsync(dataMod);
              
            });

            toast.success("Parámetros grabados!");

        } catch (error) {
          console.log("Problemas al grabar parámetros, contacte a soporte" + error);
          toast.error("Problemas al grabar parámetros, contacte a soporte");
        }
    };


  return (

    <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">


    <div className="container mx-auto p-2 md:p-2">
        <h1 className="text-2xl font-semibold mb-6">Parámetros</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">

              <div className="p-4 overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-4 py-2">Parámetro</th>
                      <th className="px-4 py-2">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paramData && paramData.length === 0 ? (
                      <tr>
                        <td colSpan="2" className="py-6 text-center">No hay parámetros.</td>
                      </tr>
                    ) : (
                      paramData.map((e, i) => (
                        <tr key={i} className="border-b hover:bg-gray-50">
                          <td className="border p-2 bg-gray-100 font-semibold">
                            {e.descripcionParametro}
                          </td>
                          <td className="px-4 py-2 font-medium">
                            <input
                              type="text"
                              className="mt-2 border border-gray-300 rounded px-2 py-1 w-full"
                              value={e.valorParametro}
                              onChange={(event) => handleInputChange(i, event)}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>


               
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <button
                    onClick={handleSubmit}
                    className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                >
                Guardar
                </button>
            </div>
        </div>
    </div>

  <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />  
</div>
  )
}

export default Parametros